import { Component, OnInit } from '@angular/core';
import { SITE_SETTINGS } from 'src/app/settings';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css']
})
export class AboutComponent implements OnInit {
  settings = SITE_SETTINGS;
  constructor() { }

  ngOnInit(): void {
  }

}
